import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/brothers",
    name: "Brothers",
    component: () =>
      import("../views/Brothers.vue")
  },
  {
    path: "/committees",
    name: "Committees",
    component: () =>
      import("../views/Committees.vue")
  },
  {
    path: "/external",
    name: "External",
    component: () =>
      import("../views/External.vue")
  },
  {
    path: "/Information",
    name: "Information",
    component: () =>
      import("../views/Information.vue")
  },
  {
    path: "/loge",
    name: "Loge",
    component: () =>
      import("../views/Loge.vue")
  },
  {
    path: "/officer",
    name: "Officer",
    component: () =>
      import("../views/Officer.vue")
  }
];

const router = new VueRouter({
  routes
});

export default router;
